import { ApiError } from '@gorila-shared-ui/components';
import { MultipleDevice } from '../types/device';
import { getRequest } from './api';
import { multipleDevicesUrl } from './urls/deviceUrls';

export const getMultipleDevices = async (
  clientId: string,
  subClientId: string,
  assetId: string
): Promise<{ multipleDevice?: MultipleDevice; error?: ApiError }> => {
  const queryParams: { [key: string]: any } = {
    clientId,
    subClientId,
    assetId,
  };
  const response = await getRequest(multipleDevicesUrl, {
    queryParams,
  });
  return {
    multipleDevice: response?.data,
    error: response?.error,
  };
};
